import { getStaticConfig, isLocal } from ':support/config';

export function shouldUseMocks() {
  const { disableAuth } = getStaticConfig();
  return isLocal() && disableAuth;
}
